import React from "react"
import SpotlightComponent from "./Spotlight"
import spotlightFactory from "./spotlight.factory"

export { default as SpotlightQuery } from "./spotlight.query"

export const Spotlight = props => {
  const { data } = props
  const componentProps = { ...props, ...spotlightFactory.transform(data) }
  return <SpotlightComponent {...componentProps} />
}
